(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[65330,14777,25591,52892],{

/***/ 12604:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/atmmachineprices/terms-and-conditions",
      function () {
        return __webpack_require__(95098);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 90638:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

"client";
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = dynamic;
exports.noSSR = noSSR;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadable = _interop_require_default(__webpack_require__(14302));
function dynamic(dynamicOptions, options) {
    let loadableFn = _loadable.default;
    let loadableOptions = (options == null ? void 0 : options.suspense) ? {} : {
        // A loading component is not required, so we default it
        loading: ({ error , isLoading , pastDelay  })=>{
            if (!pastDelay) return null;
            if (false) {}
            return null;
        }
    };
    // Support for direct import(), eg: dynamic(import('../hello-world'))
    // Note that this is only kept for the edge case where someone is passing in a promise as first argument
    // The react-loadable babel plugin will turn dynamic(import('../hello-world')) into dynamic(() => import('../hello-world'))
    // To make sure we don't execute the import without rendering first
    if (dynamicOptions instanceof Promise) {
        loadableOptions.loader = ()=>dynamicOptions;
    // Support for having import as a function, eg: dynamic(() => import('../hello-world'))
    } else if (typeof dynamicOptions === "function") {
        loadableOptions.loader = dynamicOptions;
    // Support for having first argument being options, eg: dynamic({loader: import('../hello-world')})
    } else if (typeof dynamicOptions === "object") {
        loadableOptions = _extends({}, loadableOptions, dynamicOptions);
    }
    // Support for passing options, eg: dynamic(import('../hello-world'), {loading: () => <p>Loading something</p>})
    loadableOptions = _extends({}, loadableOptions, options);
    // Error if Fizz rendering is not enabled and `suspense` option is set to true
    if (false) {}
    if (loadableOptions.suspense) {
        if (false) {}
        delete loadableOptions.ssr;
        delete loadableOptions.loading;
    }
    // coming from build/babel/plugins/react-loadable-plugin.js
    if (loadableOptions.loadableGenerated) {
        loadableOptions = _extends({}, loadableOptions, loadableOptions.loadableGenerated);
        delete loadableOptions.loadableGenerated;
    }
    // support for disabling server side rendering, eg: dynamic(import('../hello-world'), {ssr: false}).
    // skip `ssr` for suspense mode and opt-in React.lazy directly
    if (typeof loadableOptions.ssr === "boolean" && !loadableOptions.suspense) {
        if (!loadableOptions.ssr) {
            delete loadableOptions.ssr;
            return noSSR(loadableFn, loadableOptions);
        }
        delete loadableOptions.ssr;
    }
    return loadableFn(loadableOptions);
}
"client";
const isServerSide = "object" === "undefined";
function noSSR(LoadableInitializer, loadableOptions) {
    // Removing webpack and modules means react-loadable won't try preloading
    delete loadableOptions.webpack;
    delete loadableOptions.modules;
    // This check is necessary to prevent react-loadable from initializing on the server
    if (!isServerSide) {
        return LoadableInitializer(loadableOptions);
    }
    const Loading = loadableOptions.loading;
    // This will only be rendered on the server side
    return ()=>/*#__PURE__*/ _react.default.createElement(Loading, {
            error: null,
            isLoading: true,
            pastDelay: false,
            timedOut: false
        });
}
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=dynamic.js.map


/***/ }),

/***/ 16319:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.LoadableContext = void 0;
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
const LoadableContext = _react.default.createContext(null);
exports.LoadableContext = LoadableContext;
if (false) {} //# sourceMappingURL=loadable-context.js.map


/***/ }),

/***/ 14302:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports["default"] = void 0;
var _extends = (__webpack_require__(6495)/* ["default"] */ .Z);
var _interop_require_default = (__webpack_require__(92648)/* ["default"] */ .Z);
var _react = _interop_require_default(__webpack_require__(67294));
var _loadableContext = __webpack_require__(16319);
const { useSyncExternalStore  } =  true ? __webpack_require__(67294) : 0;
const ALL_INITIALIZERS = [];
const READY_INITIALIZERS = [];
let initialized = false;
function load(loader) {
    let promise = loader();
    let state = {
        loading: true,
        loaded: null,
        error: null
    };
    state.promise = promise.then((loaded)=>{
        state.loading = false;
        state.loaded = loaded;
        return loaded;
    }).catch((err)=>{
        state.loading = false;
        state.error = err;
        throw err;
    });
    return state;
}
function resolve(obj) {
    return obj && obj.__esModule ? obj.default : obj;
}
function createLoadableComponent(loadFn, options) {
    let opts = Object.assign({
        loader: null,
        loading: null,
        delay: 200,
        timeout: null,
        webpack: null,
        modules: null,
        suspense: false
    }, options);
    if (opts.suspense) {
        opts.lazy = _react.default.lazy(opts.loader);
    }
    /** @type LoadableSubscription */ let subscription = null;
    function init() {
        if (!subscription) {
            const sub = new LoadableSubscription(loadFn, opts);
            subscription = {
                getCurrentValue: sub.getCurrentValue.bind(sub),
                subscribe: sub.subscribe.bind(sub),
                retry: sub.retry.bind(sub),
                promise: sub.promise.bind(sub)
            };
        }
        return subscription.promise();
    }
    // Server only
    if (false) {}
    // Client only
    if (!initialized && "object" !== "undefined") {
        // require.resolveWeak check is needed for environments that don't have it available like Jest
        const moduleIds = opts.webpack && "function" === "function" ? opts.webpack() : opts.modules;
        if (moduleIds) {
            READY_INITIALIZERS.push((ids)=>{
                for (const moduleId of moduleIds){
                    if (ids.indexOf(moduleId) !== -1) {
                        return init();
                    }
                }
            });
        }
    }
    function useLoadableModule() {
        init();
        const context = _react.default.useContext(_loadableContext.LoadableContext);
        if (context && Array.isArray(opts.modules)) {
            opts.modules.forEach((moduleName)=>{
                context(moduleName);
            });
        }
    }
    function LoadableImpl(props, ref) {
        useLoadableModule();
        const state = useSyncExternalStore(subscription.subscribe, subscription.getCurrentValue, subscription.getCurrentValue);
        _react.default.useImperativeHandle(ref, ()=>({
                retry: subscription.retry
            }), []);
        return _react.default.useMemo(()=>{
            if (state.loading || state.error) {
                return _react.default.createElement(opts.loading, {
                    isLoading: state.loading,
                    pastDelay: state.pastDelay,
                    timedOut: state.timedOut,
                    error: state.error,
                    retry: subscription.retry
                });
            } else if (state.loaded) {
                return _react.default.createElement(resolve(state.loaded), props);
            } else {
                return null;
            }
        }, [
            props,
            state
        ]);
    }
    function LazyImpl(props, ref) {
        useLoadableModule();
        return _react.default.createElement(opts.lazy, _extends({}, props, {
            ref
        }));
    }
    const LoadableComponent = opts.suspense ? LazyImpl : LoadableImpl;
    LoadableComponent.preload = ()=>init();
    LoadableComponent.displayName = "LoadableComponent";
    return _react.default.forwardRef(LoadableComponent);
}
class LoadableSubscription {
    promise() {
        return this._res.promise;
    }
    retry() {
        this._clearTimeouts();
        this._res = this._loadFn(this._opts.loader);
        this._state = {
            pastDelay: false,
            timedOut: false
        };
        const { _res: res , _opts: opts  } = this;
        if (res.loading) {
            if (typeof opts.delay === "number") {
                if (opts.delay === 0) {
                    this._state.pastDelay = true;
                } else {
                    this._delay = setTimeout(()=>{
                        this._update({
                            pastDelay: true
                        });
                    }, opts.delay);
                }
            }
            if (typeof opts.timeout === "number") {
                this._timeout = setTimeout(()=>{
                    this._update({
                        timedOut: true
                    });
                }, opts.timeout);
            }
        }
        this._res.promise.then(()=>{
            this._update({});
            this._clearTimeouts();
        }).catch((_err)=>{
            this._update({});
            this._clearTimeouts();
        });
        this._update({});
    }
    _update(partial) {
        this._state = _extends({}, this._state, {
            error: this._res.error,
            loaded: this._res.loaded,
            loading: this._res.loading
        }, partial);
        this._callbacks.forEach((callback)=>callback());
    }
    _clearTimeouts() {
        clearTimeout(this._delay);
        clearTimeout(this._timeout);
    }
    getCurrentValue() {
        return this._state;
    }
    subscribe(callback) {
        this._callbacks.add(callback);
        return ()=>{
            this._callbacks.delete(callback);
        };
    }
    constructor(loadFn, opts){
        this._loadFn = loadFn;
        this._opts = opts;
        this._callbacks = new Set();
        this._delay = null;
        this._timeout = null;
        this.retry();
    }
}
function Loadable(opts) {
    return createLoadableComponent(load, opts);
}
function flushInitializers(initializers, ids) {
    let promises = [];
    while(initializers.length){
        let init = initializers.pop();
        promises.push(init(ids));
    }
    return Promise.all(promises).then(()=>{
        if (initializers.length) {
            return flushInitializers(initializers, ids);
        }
    });
}
Loadable.preloadAll = ()=>{
    return new Promise((resolveInitializers, reject)=>{
        flushInitializers(ALL_INITIALIZERS).then(resolveInitializers, reject);
    });
};
Loadable.preloadReady = (ids = [])=>{
    return new Promise((resolvePreload)=>{
        const res = ()=>{
            initialized = true;
            return resolvePreload();
        };
        // We always will resolve, errors should be handled within loading UIs.
        flushInitializers(READY_INITIALIZERS, ids).then(res, res);
    });
};
if (true) {
    window.__NEXT_PRELOADREADY = Loadable.preloadReady;
}
var _default = Loadable;
exports["default"] = _default; //# sourceMappingURL=loadable.js.map


/***/ }),

/***/ 95098:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ BestPostageMetersHome; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _components_shared_legal_termsAndConditions__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(10761);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);



const AtmMachinePricesWrapper = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(()=>Promise.all(/* import() */[__webpack_require__.e(92592), __webpack_require__.e(10621), __webpack_require__.e(31875), __webpack_require__.e(95660)]).then(__webpack_require__.bind(__webpack_require__, 31875)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31875)
            ]
    }
});
var __N_SSP = true;
function BestPostageMetersHome() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(AtmMachinePricesWrapper, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_legal_termsAndConditions__WEBPACK_IMPORTED_MODULE_1__["default"], {
            category: "Postage Meters",
            domain: "BestPostageMeters.com"
        })
    });
}


/***/ }),

/***/ 14777:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"primaryColor":"#16556d","lightPrimaryColor":"#dff5f9","whyUsItemTitle":"#005670","offerCallNumber":"#006336","slogan":"#018484","progressColor":"#1c75bc","linkColorDefault":"#018484","buttonBgColorDefault":"#01847f","whyUsBackgroundColor":"#005c58","whyUsColor":"#fff","melon":"#fe895c","darkSeaGreen":"#0e7d3f","marigold":"#ffcb03","fadedRed":"#cd2f32","dodgerBlue":"#4f85ff","pinkishGrey":"#bfbfbf","sea":"#329eaa","softBlue":"#6b67e9","slightlyBlack":"#161616","tealGreen":"#83b855","greyish":"#b3b3b3","paleGrey":"#f8f9fa","navy":"#011d41","pagePaddingX":"1rem","autumnGlory":"#3ea636","blackLead":"#464c4d","primary":"#b91c45","shiningSilver":"#c8c8c8","bleachedSilk":"#f3f2f2","blackBeauty":"#28252b","battleshipGrey":"#6d7577","winterSolstice":"#47525d","puritanGrey":"#a8aeaf","nero":"#242626","direWolf":"#272828","placeboBlue":"#ebf4fd","chiGong":"#ff1919","mississippiRiver":"#386189","spiroDiscoBall":"#0ac5ff","linkColor":"#565656","gray":"#eaeaea","grayBg":"#fafafa","graydark":"#b3b3b3","grayLight":"#ececec","orange":"#faa931","orangeDark":"#ff700e","orangeLight":"#f1c19c","orangePopup":"#f7951e","Blue":"#5dbbfe","blueDark":"#1b4874","green":"#0a6938","red":"#f85650","redLight":"#fff5f3","cyan":"#37c8e3","blueAster":"#266199","assault":"#184070","lucea":"#79b4e2","distantHorizon":"#f4f9fa","yellow":"#fff9e7","lynxScreenBlue":"#27aae1","singingBlue":"#0375a3","citrusSplash":"#ffc600","youngNight":"#232323","offerBorderColor":"#e4e7eb","defaultButtonColor":"#00b2b8","defaultProgressColor":"#838282","poseidon":"#143a56","vitamin":"#f90","queenOfTheNight":"#275376","trolleyGrey":"#818181","shadowMountain":"#585858","lcPrimary":"#00203f","lcSecondary":"#fdfdfd","lcLightPrimary":"#bf0a2f","lcHover":"#eef7ff","lcLink":"#ff9a03","lcButton":"#bf0a2f","lcProgress":"#9e9d9e","whyUsTitle":"#2e2e2e","whyUsItemBrief":"#747474","headerPhoneColor":"#dd6453","headerCallCenter":"#129188","goGoGreen":"#008a7b","bankVault":"#747474","secondary":"#444b53","progress":"#e489a2","hover":"#b31c1a","blue":"#0d4085","pink":"#f59aac","hoverBg":"#fef8fb","greyLight":"#f3f3f3","darkGreen":"#00a259","greenButton":"#00a259","purple":"#51378e","orangeHover":"#f1dfd0","grey":"#777","darkRed":"#ae332f","stickBtnBgColor":"#f89a1c","stickBtnBorderColor":"#f89a1c","blueLight":"#e9f9ff","carnival":"#ff9800","nickel":"#2f6177","footerColor":"#2f6177","button":"#fff2f1","darkBlue":"#222e59","lightGreen":"#d3e0c9","purpleLight":"#f6f1ff","purpleDark":"#674998","progressBarColor":"#b0b0b0","sloganColor":"#515151","phoneNumberColor":"#0d7166","popupMainColor":"#4d7ea6","stickTitleColor":"#000","stickBtnTxtColor":"#fff","progressbar":"#9a9a9a","mainColor":"#0071ac","whyUs":"#316767","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d","paragraphColor":"#232323","iconColor":"#e05d26","whyUsBriefColor":"#747474","gorseYellowOrange":"#ff9800","denimBlue":"#2f6177","legal":"legal_legal__qUt4s","ccpaMainContainer":"legal_ccpaMainContainer__EgCgv","decimalStyleOnlyLi":"legal_decimalStyleOnlyLi__qBRw_","decimalStyle":"legal_decimalStyle__ostDo","alphaStyle":"legal_alphaStyle__B5bJA","timeStyle":"legal_timeStyle__bx7dw"};

/***/ }),

/***/ 5152:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(90638)


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [10761,49774,92888,40179], function() { return __webpack_exec__(12604); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);